var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_1464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 12.4998H3.33366C2.89163 12.4998 2.46771 12.3242 2.15515 12.0117C1.84259 11.6991 1.66699 11.2752 1.66699 10.8332V3.33317C1.66699 2.89114 1.84259 2.46722 2.15515 2.15466C2.46771 1.8421 2.89163 1.6665 3.33366 1.6665H10.8337C11.2757 1.6665 11.6996 1.8421 12.0122 2.15466C12.3247 2.46722 12.5003 2.89114 12.5003 3.33317V4.1665M9.16699 7.49984H16.667C17.5875 7.49984 18.3337 8.24603 18.3337 9.1665V16.6665C18.3337 17.587 17.5875 18.3332 16.667 18.3332H9.16699C8.24652 18.3332 7.50033 17.587 7.50033 16.6665V9.1665C7.50033 8.24603 8.24652 7.49984 9.16699 7.49984Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_1464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.9f7087227c01f55426fd4b7513755f2f.svg";
export { ForwardRef as ReactComponent };